export const PRICING_PLANS = [
    {
        id: 2,
        name: 'Starter',
        users: 3,
    },
    {
        id: 3,
        name: 'Professional',
        users: 5,
    },
    {
        id: 4,
        name: 'Enterprise',
        users: 0,
    },
];

export const SUBSCRIPTION_STATUS = {
    ACTIVE: 2,
    CANCELED: 3,
    FAILED: 4,
};

export const BILLING_TIME_MAP = {
    MONTHLY: 1,
    ANNUAL: 2,
};

export const BILLING_TYPE_MAP = {
    TRIAL: 'Free Trial',
    STARTER: 'Starter',
    PROFESSIONAL: 'Professional',
    ENTERPRISE: 'Enterprise',
    FREEMIUM: 'Freemium',
    PLUSPOINT: 'Pluspoint',
};

export const PLUSPOINT_PLAN = {
    name: BILLING_TYPE_MAP.PLUSPOINT,
    users: 3,
    credits: 50,
};

export const PLUSPOINT_MIN_LOCATIONS = 3;

export const CURRENCY_MAP = {
    USD: '$',
    EUR: '€',
    GBP: '£',
    BRL: 'R$',
};

export const DIRECTORIES_ADDON_STATUS = {
    ACTIVE: 1,
    PENDING_CANCELLATION: 2,
    CANCELLED: 3,
};

export const SUBSCRIBE_STATE = {
    FREEMIUM_RETIRED: 'FREEMIUM_RETIRED',
    TRIAL_EXPIRED: 'TRIAL_EXPIRED',
};

export const FREEMIUM_RETIREMENT_DATE = '2026-07-16';

export const TRIAL_DURATION_DAYS = 14;
